// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFooterLinkedinInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="39" height="39" x=".5" y=".5" fill="#000" stroke="#333" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M16.13375,27.0021956 L13.2312498,27.0021956 L13.2312498,17.6553204 L16.13375,17.6553204 L16.13375,27.0021956 Z M14.6809373,16.3803208 C13.7528124,16.3803208 13,15.6115706 13,14.6834452 C13,13.3894589 14.4007812,12.5807173 15.5214062,13.227711 C16.0414901,13.527981 16.3618751,14.0829041 16.3618751,14.6834452 C16.3618751,15.6115706 15.6087499,16.3803208 14.6809373,16.3803208 Z M26.9968743,27.0021956 L24.1006246,27.0021956 L24.1006246,22.4521954 C24.1006246,21.36782 24.0787492,19.9771955 22.5915618,19.9771955 C21.082499,19.9771955 20.8512492,21.1553204 20.8512492,22.3740704 L20.8512492,27.0021956 L17.9518743,27.0021956 L17.9518743,17.6553204 L20.7356243,17.6553204 L20.7356243,18.930321 L20.7762494,18.930321 C21.1637492,18.195946 22.110312,17.4209454 23.5224996,17.4209454 C26.4599996,17.4209454 26.9999995,19.3553202 26.9999995,21.867821 L26.9999995,27.0021956 L26.9968743,27.0021956 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFooterLinkedinInactive);
